import { type PhoneNumber, PhoneNumberUtil } from 'google-libphonenumber';

function normalizePhoneInput(phone: string): string {
  const dotIndex = phone.indexOf('.');
  return dotIndex !== -1 ? phone.slice(0, dotIndex) + phone.slice(dotIndex + 1) : phone;
}

function parsePhoneInfo(phone: string): PhoneNumber | null {
  try {
    return PhoneNumberUtil.getInstance().parse(normalizePhoneInput(phone));
  } catch {
    return null;
  }
}

function getPhoneRegion(phone: string): string {
  const parsed = parsePhoneInfo(phone);
  if (!parsed) return '';
  const regionCode = PhoneNumberUtil.getInstance().getRegionCodeForNumber(parsed) as string | undefined;
  if (!regionCode || regionCode === 'ZZ' || regionCode === '001') return '';
  return regionCode.toLowerCase();
}

function convertToClientProfileFormat(phone: string): string {
  if (!phone) return '';
  try {
    const parsed = PhoneNumberUtil.getInstance().parse(normalizePhoneInput(phone));
    const cc = parsed.getCountryCode();
    const national = parsed.getNationalNumber();
    if (!cc || national === undefined || national === null) return phone;
    return `+${cc}.${national}`;
  } catch {
    return phone;
  }
}

export { parsePhoneInfo, getPhoneRegion, convertToClientProfileFormat };

